import { LitElement, html } from 'lit';
import classNames from 'classnames';
import { t } from '@lingui/macro';
import { formatDistanceLocaleFunc, NetworksCommonName } from '../../../utils';
import { getFAIcon } from '../../masonry-utils';
import { NETWORK_ICONS } from '../../../consts';

// eslint-disable-next-line
import styles from '!!lit-css-loader!postcss-loader!sass-loader!./PostInfo.scss';

class PostInfo extends LitElement {
  static styles = [styles];

  static get properties() {
    return {
      profilePic: { type: String },
      fullname: { type: String },
      username: { type: String },
      service: { type: String },
      date: { type: Number },
      bottom: { type: Boolean },
      overlay: { type: Boolean },
    };
  }

  render() {
    const network = NetworksCommonName[this.service];
    const formatDistance = formatDistanceLocaleFunc();

    return html`
      <div
        class=${classNames('post-info', {
          'post-info--bottom': this.bottom,
          'post-info--overlay': this.overlay,
        })}
      >
        <div class="post-info__userinfo">
          <div class="post-info__handle">${this.username ? html`@${this.username}` : ''}</div>
          ${!this.disableDates && this.date
            ? html`
                <div class="post-info__date">
                  ${formatDistance(new Date(this.date || 0), new Date())} ${t`ago`}
                </div>
              `
            : ''}
        </div>
        <div class=${classNames('post-info__social-icon', `post-info__social-icon--${network}`)}>
          ${getFAIcon(NETWORK_ICONS[network])}
        </div>
      </div>
    `;
  }
}

export default PostInfo;
